(function () {
  if (window.__sdcLoaded) return;
  window.__sdcLoaded = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }

  function updateCount(count) {
    document.querySelectorAll('.sd-header-tools a[href$="/cart"]').forEach(function (a) {
      var s = a.querySelector('span');
      if (!s && count > 0) { s = document.createElement('span'); a.appendChild(s); }
      if (s) { if (count > 0) s.textContent = count; else s.remove(); }
    });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var d = drawer();
    var added = false;
    var fd = new FormData(form);
    if (d) fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.setAttribute('disabled', 'disabled');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        added = true;
        if (d && typeof d.renderContents === 'function' && res.sections) {
          try { d.renderContents(res); d.classList.remove('is-empty'); }
          catch (err) { window.location.href = root + 'cart'; return; }
        } else { window.location.href = root + 'cart'; return; }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
      })
      .catch(function () { if (added) { window.location.href = root + 'cart'; } else { form.submit(); } })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches) return;
    var isAdd = (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
    if (!isAdd || !(form.closest('.sd-home') || form.closest('.sdc-upsell'))) return;
    if (!drawer()) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.sd-header-tools a[href$="/cart"]');
    var d = drawer();
    if (!a || !d || typeof d.open !== 'function') return;
    e.preventDefault();
    d.open(a);
  });

  // Shop page: filter chips and variant price sync
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-sdc-filter]');
    if (!chip) return;
    var shop = chip.closest('.sdc-shop');
    if (!shop) return;
    var f = chip.getAttribute('data-sdc-filter');
    var shown = 0;
    shop.querySelectorAll('.sdc-card').forEach(function (c) {
      var ok = f === 'all' || c.getAttribute('data-sdc-kind') === f;
      c.hidden = !ok; if (ok) shown++;
    });
    shop.querySelectorAll('.sdc-chip').forEach(function (b) {
      var on = b.getAttribute('data-sdc-filter') === f;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var empty = shop.querySelector('.sdc-empty');
    if (empty) empty.hidden = shown > 0;
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.sdc-pills input[name="id"]')) return;
    var form = input.closest('form');
    var p = form.querySelector('[data-sdc-price]'), s = form.querySelector('[data-sdc-compare]');
    if (p) p.textContent = input.getAttribute('data-price');
    if (s) s.textContent = input.getAttribute('data-compare') || '';
  });

  // Free delivery progress + upsell inside the cart drawer
  var cfg = null;
  function readCfg() {
    if (cfg) return cfg;
    var el = document.getElementById('sdc-cart-config');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (err) { cfg = null; }
    return cfg;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var rendering = false, timer = null;
  function renderExtras() {
    var c = readCfg();
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!c || !inner) return;
    rendering = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        var old = inner.querySelector('.sdc-drawer-extras');
        if (old) old.remove();
        if (!cart.item_count) return;
        var fmt = function (cents) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cart.currency }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } };
        var html = '';
        if (c.country === c.shipCountry && c.threshold) {
          var pct = Math.min(100, Math.round(cart.total_price / c.threshold * 100));
          var msg = cart.total_price >= c.threshold
            ? '<strong>You’ve unlocked free UK delivery.</strong>'
            : 'You’re <strong>' + fmt(c.threshold - cart.total_price) + '</strong> away from <strong>free UK delivery</strong>.';
          html += '<div class="sdc-ship" role="status">' + msg + '<div class="sdc-ship__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div></div>';
        }
        var u = c.upsell;
        var inCart = u && cart.items.some(function (i) { return i.handle === u.handle; });
        if (u && !inCart) {
          html += '<div class="sdc-upsell">' + (u.image ? '<img src="' + esc(u.image) + '" alt="" width="56" height="56" loading="lazy">' : '') +
            '<div class="sdc-upsell__body"><strong>' + esc(u.title) + '</strong>' + esc(u.text) + ' · ' + esc(u.price) + (u.compare ? ' <s>' + esc(u.compare) + '</s>' : '') + '</div>' +
            '<form action="' + root + 'cart/add" method="post"><input type="hidden" name="id" value="' + esc(u.variantId) + '"><button type="submit">Add</button></form></div>';
        }
        if (!html) return;
        var wrap = document.createElement('div');
        wrap.className = 'sdc-drawer-extras';
        wrap.style.padding = '0 3rem';
        wrap.innerHTML = html;
        var head = inner.querySelector('.drawer__header');
        if (head && head.nextSibling) head.parentNode.insertBefore(wrap, head.nextSibling); else inner.prepend(wrap);
      })
      .catch(function () {})
      .finally(function () { setTimeout(function () { rendering = false; }, 50); });
  }
  function watchDrawer() {
    var d = drawer();
    if (!d || d.__sdcWatch) return;
    d.__sdcWatch = true;
    new MutationObserver(function (muts) {
      if (rendering) return;
      var relevant = muts.some(function (m) { return !(m.target.closest && m.target.closest('.sdc-drawer-extras')); });
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(renderExtras, 120);
    }).observe(d, { childList: true, subtree: true });
    renderExtras();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
